<template>
<div>
   <div class="leftformitem">
    <div class="leftformtitle">{{property.name}}<span v-if="property.checked" class="ischeck">*</span></div>
    <div class="leftformbd"><div class="leftforminput">请输入</div></div>
  </div>
  <div class="leftformitem" v-if="property.radio==1&&property.radio2==1">
    <div class="leftformtitle">验证码</div>
    <div class="leftformbd"></div>
    <div class="form-getcode">获取验证码</div>
  </div>
</div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>



 